<template>
  <div
    class="bg-opacity-40 fixed inset-0 z-[9999] flex items-center justify-center p-4"
    :class="mode === 'dark' ? 'bg-white-100' : 'bg-black-100'"
  >
    <div
      class="max-w-2xl rounded-xl w-full mx-auto"
      :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
    >
      <div
        class="flex items-center justify-between p-4 border-b"
        :class="mode === 'dark' ? 'border-dark-50' : ''"
      >
        <h5 class="font-medium text-[17px] leading-none">
          Your article is being auto-generated
        </h5>
        <X
          :size="22"
          :stroke-width="1.75"
          @click="closeModal"
          class="cursor-pointer"
        />
      </div>
      <div
        class="without-scrollbar max-h-modal overflow-y-auto p-4 rounded-bl-xl rounded-br-xl"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-gray-20 bg-opacity-30'"
      >
        <div class="grid gap-4">
          <p class="text-[15px]">
            Your Article is being auto-generated. We are working hard to
            generate your high-quality SEO article. Please wait a few minutes
            while we complete this process.
          </p>
          <div class="grid gap-2">
            <p class="text-[15px]">
              Once the process is done, you'll see the following indicators:
            </p>
            <ul class="list-disc pl-4 grid gap-1">
              <li class="text-[15px]">
                <div class="flex items-center gap-2">
                  The status will show 100% complete:
                  <div
                    class="flex items-center gap-2 bg-white-100 p-2 rounded-md shadow-card"
                  >
                    <div class="w-14">
                      <div class="h-[5px] rounded-lg w-full bg-gray-20">
                        <div
                          class="w-full h-full rounded-md transition-all max-w-full bg-primary-100"
                        ></div>
                      </div>
                    </div>
                    <label>100%</label>
                  </div>
                </div>
              </li>
              <li class="text-[15px]">
                <div class="flex items-center gap-2">
                  A green checkmark will appear next to the AI Article:
                  <div
                    class="bg-white-100 px-2 py-1 rounded-md shadow-card text-success-100"
                  >
                    <ClipboardCheck :size="20" :stroke-width="1.75" />
                  </div>
                </div>
              </li>
              <li class="text-[15px]">
                <div class="flex items-center gap-2">
                  A "Go to Article Builder" button will be displayed.
                  <div class="bg-white-100 p-2 rounded-md shadow-card">
                    <div
                      class="h-8 px-2 bg-primary-100 text-white-100 rounded-md flex items-center"
                    >
                      Go to Article Builder
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <p class="text-[15px]">
            Don't worry if you don't understand SEO! We've done most of the work
            for you. The FINAL STEP is to inspect and read the final Article in
            the Article Builder, and make any necessary changes to ensure the
            wording applies to your business.
          </p>
          <p class="text-[15px]">
            Please wait for the green checkmark and "Go to Article Builder"
            button before proceeding.
          </p>
          <p class="text-[15px]">Thank you for your patience!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from "./../stores/user";
import { ClipboardCheck, X } from "lucide-vue-next";

export default {
  setup() {
    const userStore = useUserStore();
    return {
      userStore,
    };
  },
  props: {
    mode: String,
  },
  components: {
    X,
    ClipboardCheck,
  },
  methods: {
    closeModal() {
      this.userStore.setAutoGeneratedArticleInfoModalStatus(false);
    },
  },
};
</script>
